/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCross = createReactComponent("outline", "cross", "IconCross", [["path", { "d": "M10 21h4v-9h5v-4h-5v-5h-4v5h-5v4h5z", "key": "svg-0" }]]);

export { IconCross as default };
//# sourceMappingURL=IconCross.mjs.map
